export default "__VITE_ASSET__CndhZQWL__"